import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { selectSubscriptionList } from 'root-redux/selects/common'

import { getAxonItem } from 'helpers/getAxonItem'

type TParams = {
  enabled?: boolean
}

export const useApplovinViewItemEvent = ({ enabled = true }: TParams = {}) => {
  const subscriptions = useSelector(selectSubscriptionList)
  const subscriptionsBeforeLoad = useRef(subscriptions)

  useEffect(() => {
    if (!enabled || !subscriptions.length) return
    if (subscriptions === subscriptionsBeforeLoad.current) return

    window.axon &&
      window.axon('track', 'view_item', {
        currency: subscriptions[0].currency.toUpperCase(),
        items: getAxonItem(subscriptions),
      })
  }, [enabled, subscriptions])
}
